import { debounce } from "lodash";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

const useExplore = () => {
  // state

  // variables

  // logics before hooks

  // hooks
  const [searchParams, setSearchParams] = useSearchParams();

  // logics
  const updateSearchParams = (values) => {
    for (const key of Object.keys(values)) {
      if (Array.isArray(values[key])) {
        searchParams.delete(key);
        for (const value of values[key]) {
          searchParams.append(key, value);
        }
      } else searchParams.set(key, values[key]);
    }
    searchParams.set("PageNumber", 1);
    searchParams.sort();
  };

  const filter = (values) => {
    updateSearchParams(values);
    setSearchParams(searchParams, { replace: true });
  };

  const resetFilters = (keepParams = []) => {
    const removeParams = [];
    for (const key of searchParams.keys()) {
      if (!keepParams.includes(key)) removeParams.push(key);
    }
    for (const key of removeParams) searchParams.delete(key);
    searchParams.sort();
    setSearchParams(searchParams, { replace: true });
  };

  const search = useCallback(
    debounce((Keyword) => {
      if (
        !Keyword ||
        Keyword.replace(/[^\w\s']|_/g, "")
          .replace(/\s+/g, " ")
          .trim()
      ) {
        updateSearchParams({ Keyword });
        setSearchParams(searchParams, { replace: true });
      }
    }, 500),
    []
  );

  const sort = (Orderby) => {
    updateSearchParams({ Orderby });
    setSearchParams(searchParams, { replace: true });
  };

  const changePageSize = (PageSize) => {
    updateSearchParams({ PageSize });
    setSearchParams(searchParams, { replace: true });
  };

  // UI partials

  // effects

  // render
  return { search, sort, filter, resetFilters, changePageSize };
};

export { useExplore };
